//import { init as initApm } from '@elastic/apm-rum'
import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom"
import Af from "./componentes/af"
import Ajuda from "./componentes/ajuda"
import ConsultarEnvios from "./componentes/consultarEnvios"
import DistVaf from "./componentes/distvaf"
import Download from "./componentes/download"
import EditarAf from "./componentes/editarAf"
import EditarPrefeitura from "./componentes/editarPrefeitura"
import EditarSrf from "./componentes/editarSrf"
import Enviar from "./componentes/enviar"
import EnviarInformativo from "./componentes/enviarInformativo"
import HistoricoAf from "./componentes/historicoAf"
import HistoricoPrefeitura from "./componentes/historicoPrefeitura"
import HistoricoSrf from "./componentes/historicoSrf"
import Prefeitura from "./componentes/prefeitura"
import Srf from "./componentes/srf"
import Login from "./componentes/login"
import useToken from './useToken';
import SolicitaAtualizacaoPrefeitura from './componentes/atualizacaoSolicitar'
import AprovaAtualizacaoPrefeitura from './componentes/atualizacaoAprovar'
import VisualizaAtualizacaoPrefeitura from './componentes/atualizacaoVisualizar'
import packageJson from '../package.json';

function App() {
	
	//initApm({
		//serviceName: 'distvaf-frontend',
		//serverUrl: 'https://apm-server-elk.fazenda.mg.gov.br',
		//environment: process.env.REACT_APP_ENVIRONMENT || 'DISTVAF_FRONT_DESENVOLVIMENTO'
		
		//enabled:true,
		//server-url: 'https://elastic-sef.apm.elk.fazenda.mg.gov.br:9243',
		//service-name: process.env.REACT_APP_ENVIRONMENT || 'DISTVAF_FRONT_DESENVOLVIMENTO',
		//application-packages: 'distvaf-frontend',
		//log-level: INFO,
		//verify-server-cert: false,
		//secret_token: ${ELASTIC_APM_SECRET_TOKEN}
	//});
	
	// Log application startup to APM
	//if (window.elasticApm) {
		//	window.elasticApm.captureMessage('DISTVAF_FRONT application started', 'info');
		//	window.elasticApm.captureMessage(process.env.REACT_APP_ENVIRONMENT);
		//}
	
		
		
	const { token, setToken } = useToken();
	if (!token) {
		//A tela atualizacaoSolicitar é de acesso externo
		if(window.location.href.indexOf("atualizacaoSolicitar") > -1){
			return <SolicitaAtualizacaoPrefeitura />
		}
		else if(window.location.href.indexOf("public/CADASTRAMENTO_DE_E-MAIL_PREFEITURAS.doc") > -1){
			//iniciar download do arquivo .doc
			return <Download href="public/CADASTRAMENTO_DE_E-MAIL_PREFEITURAS.doc"/>
		} 
		else{
			return <Login setToken={setToken} />
		}
	}

	return (
		<BrowserRouter>
			<div id="wrapper">
				<div id="main">
					<div className="inner ">
						<header id="header">
							<link rel="preconnect" href="https://fonts.googleapis.com" />
							<link rel="preconnect" href="https://fonts.gstatic.com" />
							<link
							rel="stylesheet"
							href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap"
							/>

							<div className="container-fluid">
								<div className="row App-header">
									<a href="/" className="logo"><img src="/logo_fazenda_280_163.png" alt="Início" style={{maxHeight: "70%"}} width="auto"/></a>
								</div>
							</div>
						</header>
						<Routes>
							<Route path="/" element={<DistVaf />} />
							<Route path="/distvaf" element={<DistVaf />} />
							<Route path="/distvaf/af" element={<Af />} />
							<Route path="/distvaf/ajuda" element={<Ajuda />} />
							<Route path="/distvaf/consultarEnvios" element={<ConsultarEnvios />} />
							<Route path="/distvaf/download" element={<Download />} />
							<Route path="/distvaf/enviar" element={<Enviar />} />
							<Route path="/distvaf/enviarInformativo" element={<EnviarInformativo />} />
							<Route path="/distvaf/editarAf/:id" element={<EditarAf />} />
							<Route path="/distvaf/editarPrefeitura/:id" element={<EditarPrefeitura />} />
							<Route path="/distvaf/editarSrf/:id" element={<EditarSrf />} />
							<Route path="/distvaf/historicoAf/:id" element={<HistoricoAf />} />
							<Route path="/distvaf/historicoPrefeitura/:id" element={<HistoricoPrefeitura />} />
							<Route path="/distvaf/historicoSrf/:id" element={<HistoricoSrf />} />
							<Route path="/distvaf/prefeitura" element={<Prefeitura />} />
							<Route path="/distvaf/srf" element={<Srf />} />
							<Route path="/distvaf/atualizacaoSolicitar" element={<SolicitaAtualizacaoPrefeitura />} />
							<Route path="/distvaf/atualizacaoAprovar" element={<AprovaAtualizacaoPrefeitura />} />
							<Route path="/distvaf/atualizacaoVisualizar" element={<VisualizaAtualizacaoPrefeitura />} />
							<Route path='public/CADASTRAMENTO_DE_E-MAIL_PREFEITURAS.doc' element={<SolicitaAtualizacaoPrefeitura />} />

							<Route path="*" element={
								<main style={{ padding: "1rem" }}>
									<p>Opção não existente!</p>
								</main>
							} />
						</Routes>
						<footer id="footer">
							<div className="inner App-footer-slin">
								<p>Rodovia Papa João Paulo II, 4.001 - Prédio
					Gerais (6º e 7º andares) - Bairro Serra Verde, Belo Horizonte/MG CEP 31630-901 - {packageJson.version}</p>
							</div>
						</footer>
					</div>
					
				</div>
				
			</div>
		</BrowserRouter>
	);
}

export default App;